//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  angular.module('curalate').service('CollectionsService', [
    '$log',
    'CollectionsApiService',
    'COLLECTION_SETTINGS',
    'rx',
    function(
            $log,
            CollectionsApiService,
            COLLECTION_SETTINGS,
            rx,
        ) {
      const self = this;

      let latestState;

      const initialState = {
        collections: [],
      };
      const updates = new rx.BehaviorSubject(initialState);

      const collectionsNotifications = new rx.Subject();
      const collections = updates.scan((state, action) => {
        const newState = angular.copy(state);
        switch (action.type) {
          case COLLECTION_SETTINGS.NOTIFICATIONS.REFRESH:
            newState.collections = action.collections;
            break;
          default:
            $log.error(`unrecognized type: ${action.type}`);
            break;
        }
        latestState = angular.copy(newState);
        return newState;
      });

      this.buildState = (collectionId) => {
        if (!collectionId) {
          return undefined;
        } else {
          return {
            name: 'library.collections.content',
            params: {
              collectionId,
            },
          };
        }
      };

      this.collectionExists = (collectionId) => {
        let exists = true;
        if (latestState) {
          exists = !!_(latestState.collections).findWhere({ id: collectionId });
        }
        return exists;
      };

      this.getCollections = function() {
        return collections;
      };

      this.getCollectionsNotifications = function() {
        return collectionsNotifications;
      };

      this.updateCollectionName = function(collectionId, name) {
        CollectionsApiService.updateCollectionNameAsync(collectionId, name).then(() => {
          self.refreshCollections();
        });
      };

      this.updateCollection = function(collectionId, params) {
        const updatePromise = CollectionsApiService.saveCollectionsSettingsAsync(collectionId, params);
        updatePromise.then(() => {
          self.refreshCollections().subscribe(() => {
            collectionsNotifications.next({
              type: COLLECTION_SETTINGS.NOTIFICATIONS.UPDATE,
              actionRelevantId: collectionId,
            });
          });
        }).catch((error) => {
          collectionsNotifications.next({
            type: COLLECTION_SETTINGS.NOTIFICATIONS.ERROR.UPDATE,
            actionRelevantId: collectionId,
            error,
          });
        });

        return updatePromise;
      };

      this.createCollectionWithoutNotification = function(params) {
        return rx.Observable.fromPromise(CollectionsApiService.createCollectionAsync(params)).flatMap((newCollection) => {
          return self.refreshCollections().map(() => {
            return newCollection;
          });
        });
      };

      this.createCollection = function(collectionId, params) {
        const createPromise = CollectionsApiService.createCollectionAsync(params);
        createPromise.then((newCollection) => {
          self.refreshCollections().subscribe(() => {
            collectionsNotifications.next({
              type: COLLECTION_SETTINGS.NOTIFICATIONS.CREATE,
              actionRelevantId: newCollection.id,
            });
          });
        }).catch((error) => {
          collectionsNotifications.next({
            type: COLLECTION_SETTINGS.NOTIFICATIONS.ERROR.CREATE,
            actionRelevantId: collectionId,
            error,
          });
        });

        return createPromise;
      };

      this.deleteCollection = function(collectionId) {
        return CollectionsApiService.deleteCollectionAsync(collectionId).then(() => {
          if (latestState) {
            latestState.collections = _.filter(latestState.collections, (collection) => {
              return collection.id !== collectionId;
            });
          }
          self.refreshCollections().subscribe(() => {
            collectionsNotifications.next({
              type: COLLECTION_SETTINGS.NOTIFICATIONS.DELETE,
              actionRelevantId: collectionId,
            });
          });
        });
      };

      this.refreshCollections = function() {
        const refreshObservable = rx.Observable.fromPromise(CollectionsApiService.getAllCollections());

        refreshObservable.subscribe((response) => {
          updates.next({
            type: COLLECTION_SETTINGS.NOTIFICATIONS.REFRESH,
            collections: response,
          });
        });

        return refreshObservable;
      };

            // initialize the service
      this.refreshCollections();
    },
  ]);
})();
